<script>
export default {
    sign_in_with: 'Accedi con',
    or_sign_in_with_credentials: 'Oppure accedi con le credenziali',
    sign_up_with: 'Registrati con',
    generic_error: 'Si è verificato un errore. Per favore riprova più tardi.',
    i_agree_with_the: 'Accetto i ',
    we_have_sent_you_an_email: "Ti abbiamo inviato un'email :-)",
    email: 'Email',
    password: 'Password',
    lost_your_password: 'Hai perso la password?',
    recovery_here: 'recuperala qui',
    sign_in: 'Accedi',
    forgot_password: 'Password dimenticata?',
    create_new_account: 'Crea nuovo account',
    terms_of_service: 'Termini di Servizio',
    link_privacy: 'Politica sulla Privacy',
    term_conditions_text: 'Registrandoti o accedendo con uno dei servizi sopra menzionati, acconsenti ai nostri {link_terms} e riconosci la nostra {link_privacy}, che descrive come gestiamo i tuoi dati personali.',
    about_us: 'Chi Siamo',
    blog: 'Blog',
    mit_license: 'Licenza MIT',
    docs: 'Documenti',
    loading: 'Caricamento',
    dashboard: 'Dashboard',
    add_new_entry: 'Aggiungi nuova voce',
    add_new_model: 'Aggiungi nuovo modello',
    my_entries: 'Le mie voci',
    search_entries: 'Cerca voci',
    payee_list: 'Elenco debiti',
    planned_entries: 'Voci pianificate',
    budgets: 'Budget',
    settings: 'Impostazioni',
    logout: 'Esci',
    expenses: 'Spese',
    incoming: 'Entrate',
    transfer: 'Trasferimento',
    debit: 'Debiti',
    choose_one_of_currently_tags: 'Scegli uno dei tag attuali',
    choose_a_wallet_to_transfer_to: 'Scegli un portafoglio a cui trasferire',
    choose_wallet_account: 'Scegli account del portafoglio',
    choose_wallet_to_transfer: 'Scegli un portafoglio a cui trasferire',
    payment_confirg: 'Conferma pagamento',
    choose_an_option: "Scegli un'opzione",
    choose_a_model: 'Scegli un modello',
    out_of_wallet: 'Fuori dal portafoglio',
    insert_new_tag_name: 'Inserisci nuovo nome TAG',
    add_here_your_note: 'Aggiungi qui la tua nota',
    insert_new_entry: 'Inserisci nuova voce',
    show_planned_entries: 'Mostra voci pianificate',
    show_more: 'Mostra di più',
    restore: 'Ripristina',
    reasume_of_all_entries: 'Riepilogo di tutte le voci',
    list_of_all_payees: 'Elenco di tutti i debiti',
    forget_debit: 'Dimentica addebito',
    date_start: 'Data inizio',
    debit_name: 'Nome addebito',
    date_end: 'Data fine',
    choose_frequency: 'Scegli una frequenza',
    choose_method: 'Scegli un metodo',
    insert_new_planned_entry: 'Inserisci nuova voce pianificata',
    create_new_budget: 'Crea nuovo budget',
    budget_name: 'Nome budget',
    period: 'Periodo',
    budget: 'Budget',
    account: 'Account',
    category: 'Categoria',
    label: 'Etichetta',
    labels: 'Etichette',
    entry_type: 'Tipo di voce',
    enable_email_notification: 'Abilita notifica email',
    save_budget: 'Salva budget',
    add_new_wallet: 'Aggiungi nuovo portafoglio',
    show_archived: 'Mostra archiviati',
    wallet_settings: 'Impostazioni portafoglio',
    category_settings: 'Impostazioni categoria',
    add_new_category: 'Aggiungi nuova categoria',
    category_name: 'Nome categoria',
    save_changes: 'Salva modifiche',
    archive_label: 'Archivia etichetta',
    add_model_entry: 'Aggiungi nuova voce modello',
    model_settings: 'Impostazioni modello',
    set_your_default_currency: 'Imposta la tua valuta predefinita',
    currency_settings: 'Impostazioni valuta',
    wallets: 'Portafogli',
    models: 'Modelli',
    categories: 'Categorie',
    currency: 'Valuta',
    profile: 'Profilo',
    assistance: 'Assistenza',
    my_entry: 'La mia voce',
    is_planned: 'Pianificati',
    add: 'Aggiungi',
    model: 'Modello',
    wallet: 'Portafoglio',
    payee: 'Beneficiario',
    frequency: 'Frequenza',
    method: 'Metodo',
    amount: 'Importo',
    date: 'Data',
    tag: 'Tag',
    tags: 'Tag',
    note: 'Nota',
    save: 'Salva',
    cancel: 'Annulla',
    close: 'Chiudi',
    confirm: 'Conferma',
    delete: 'Elimina',
    edit: 'Modifica',
    show: 'Mostra',
    hide: 'Nascondi',
    archive: 'Archivia',
    unarchive: 'Disarchivia',
    search: 'Cerca',
    search_labels: 'Cerca etichette...',
    or_insert_new_tag_name: 'Oppure inserisci un nuovo nome di etichetta',
    show_details: 'Mostra dettagli',
    bounce_rate: 'Differenza',
    session_duration: 'Durata sessione',
    amount_before: 'Importo precedente',
    send_a_request: 'Invia una richiesta',
    change_order: 'Cambia ordine',
    add_new_workspace: 'Aggiungi nuovo spazio di lavoro',
    set_up_your_workspaces: 'Configura i tuoi spazi di lavoro',
    choose_parent_category: 'Scegli una categoria principale',
    exclude_from_stats: 'Escludi dalle statistiche',
    label_color: 'Colore etichetta',
    choose_currency: 'Scegli una valuta',
    choose_wallet_type: 'Scegli un tipo di portafoglio',
    payment_deadline: 'Scadenza pagamento',
    credit_card_installment: 'Rata della carta di credito',
    wallet_color: 'Colore portafoglio',
    workspace_settings: 'Impostazioni spazio di lavoro',
    default_currency: 'Valuta predefinita',
    default_payment_type: 'Tipo di pagamento predefinito',
    share_workspace_with: 'Condividi spazio di lavoro con',
    share: 'Condividi',
    remove: 'Rimuovi',
    workspace_shared_with: 'Spazio di lavoro condiviso con',
    choose_a_category: 'Scegli una categoria',
    payment_confirm: 'Conferma pagamento',
    my_planned: 'Pianificati',
    my_health: 'Salute economica',
    workspace: 'Workspace',
    entry_saved: 'Voce salvata correttamente',
    could_not_log_in: 'Non riesco ad accedere',
    send_my_password: 'Invia una nuova password',
    recovery_your_password: 'Recupera la tua password',
    name: 'Nome',
    confirm_password: 'Conferma password',
    privacy_policy: 'Privacy & Policy',
    create_account: 'Crea un nuovo account',
    click_here: 'Clicca qui',
    save_template: 'Salva modello',
    set_new_password: 'Imposta nuova password',
    account_created: 'Account creato con successo, verifica la tua email per confermare ed attivare il tuo account',
    search_by_text: 'Cerca per testo',
    no: 'NO',
    yes: 'SI',
    date_interval: 'Intervallo di date',
    type_of_transaction: 'Tipo di transazione',
    choose_period: 'Scegli un periodo',
    daily: 'Giornaliero',
    weekly: 'Settimanale',
    monthly: 'Mensile',
    yearly: 'Annuale',
    one_shot: 'Una tantum',
    recursive: 'Ricorrente',
    or_nsert_new_tag_name: 'Oppure inserisci un nuovo nome TAG',
    no_budgets_found: 'Nessun budget trovato',
    list_of_entries_of: 'Elenco delle voci di',
    no_payees_found: 'Nessun debito trovato',
    list_of_all_budgets: 'Elenco di tutti i budget',
    list_of_all_planned_entries: 'Elenco di tutte le voci pianificate',
    set_your_default_currecny: 'Imposta la tua valuta predefinita',
    update: 'Aggiorna',
    stats: 'Statistiche',
    payment_types: 'Tipi di pagamento',
    create_new_debit: 'Crea nuovo debito',
    months: {
        jan: 'Gen',
        january: 'Gennaio',
        feb: 'Feb',
        february: 'Febbraio',
        mar: 'Mar',
        march: 'Marzo',
        apr: 'Apr',
        april: 'Aprile',
        may: 'Mag',
        jun: 'Giu',
        june: 'Giugno',
        jul: 'Lug',
        july: 'Luglio',
        aug: 'Ago',
        august: 'Agosto',
        sep: 'Set',
        september: 'Settembre',
        oct: 'Ott',
        october: 'Ottobre',
        nov: 'Nov',
        november: 'Novembre',
        dec: 'Dic',
        december: 'Dicembre',
    },
    closing_account_statement: 'Chiusura estratto conto',
    account_payment: 'Conto di pagamento',
    start_date: 'Data di inizio',
    end_date: 'Data di fine',
    show_entries: 'Mostra voci',
    wallet_name: 'Nome del portafoglio',
    balance_wallet: 'Saldo del portafoglio',
    wallet_type: 'Tipo di portafoglio',
    next_execution_time: 'Prossimo data di esecuzione',
    end_time: 'Data di fine',
    no_data_found: 'Nessun dato trovato',
    average_incoming: 'Entrate medie',
    average_savings: 'Risparmi medi',
    your_planned_expenses: 'Spese pianificate',
    average_expenses: 'Spese medie',
    list_of_voices: 'Elenco delle voci',
    no_voices_found: 'Nessuna voce trovata',
    workspace_whared_with: 'Spazio di lavoro condiviso con',
    user_not_found: 'Utente non trovato',
    save_as_model: 'Salva come modello',
    write_temlate_name: 'Scrivi il nome del modello',
    end_of_month: 'Previsione Fine mese',
    ticket_value: 'Valore del voucher',
    spent: 'speso',
    remaining: 'rimanente',
    planned: 'pianificato',
    no_entries_found: 'Nessuna voce trovata',
    credit_card_installement: 'Rata della carta di credito',
    choose_planned_type: 'Scegli un tipo pianificato',
    list_of_all_credit_cards: 'Elenco di tutte le carte di credito',
    details: 'Dettagli',
    planned_entry: 'Pianificati',
    back_to_login: 'Torna al login',
    workspace_name: 'Nome del tuo workspace',
    first_wallet_name: 'Nome del tuo primo portafoglio',
    wallet_amount: "Saldo del portafoglio",
    setup_account: 'Configura account',
    donate: 'Donazione',
    faq: 'FAQ',
    start_Date: 'Data di inizio',
    savings: 'Risparmi',
    paid_debits: 'Debiti',
    given_on_loan: 'Dato in prestito',
    loans: 'Prestiti',
    goals: 'Obiettivi',
    list_of_all_goals: 'Elenco di tutti gli obiettivi',
    no_goals_found: 'Nessun obiettivo trovato',
    add_new_goal: 'Aggiungi nuovo obiettivo',
    target_amount: 'Importo',
    goal_name: 'Nome dell\'obiettivo',
    goal_target: 'Data di arrivo',
    goal_note: 'Note',
    icons: {
        house: 'Casa',
        car: 'Auto',
        travel: 'Viaggio',
        education: 'Istruzione',
        health: 'Salute',
        savings: 'Risparmi',
        retirement: 'Pensione',
        business: 'Affari',
        charity: 'Beneficenza',
        family: 'Famiglia',
        hobby: 'Hobby',
        investment: 'Investimento',
        emergency: 'Emergenza',
        vacation: 'Vacanza',
        home_improvement: 'Ristrutturazione',
        technology: 'Tecnologia',
        pets: 'Animali domestici',
        other: 'Altro',
    },
    goal_type: 'Tipo di obiettivo',
    activity: 'Attività',
    deposit: 'Deposito',
    saved: 'Risparmiato',
    my_goal: 'Il mio obiettivo',
    my_goals: 'I miei obiettivi',
    current_saved: 'Attualmente risparmiato',
    monthly_deposit: 'Deposito mensile',
    due_date: 'Data di scadenza',
    description: 'Descrizione',
    choose_a_goal: 'Seleziona un obbiettivo',
    withdrawal: 'Prelievo',
    choose_payment_type: 'Scegli tipo di pagamento',
    no_goals_available: 'Nessun obiettivo disponibile',
    create_goal_to_start_saving: 'Crea un obiettivo per iniziare a risparmiare',
    create_first_goal: 'Crea il tuo primo obiettivo',
    operation_type: 'Tipo di operazione',
    attention: 'Attenzione',
    choose_payee: 'Scegli beneficiario',
    insert_payee_name: 'Inserisci nome beneficiario',
    wallets_must_be_different: 'I portafogli devono essere diversi',
    create_goal_first: 'Crea prima un obiettivo',
    label_input_hint: 'Puoi aggiungere più etichette separandole con spazi',
    no_models_available: 'Nessun modello disponibile',
    create_first_model: 'Crea il tuo primo modello',
    your_goal: 'Il tuo obiettivo',
    confirm_delete_goal: 'Conferma eliminazione obiettivo',
    remaining_expenses: 'Spese rimanenti',
    wallet_management: 'Gestione portafoglio',
    wallet_management_description: 'Gestisci i tuoi portafogli, aggiungine di nuovi e imposta il tuo portafoglio predefinito.',
    add_first_wallet: 'Aggiungi il tuo primo portafoglio',
    no_wallets_available: 'Nessun portafoglio disponibile',
    create_first_wallet: 'Crea il tuo primo portafoglio',
    archived: 'Archiviato',
    last_updated: 'Ultimo aggiornamento',
    active_wallets: 'Portafogli attivi',
    all_wallets: 'Tutti i portafogli',
    archived_wallets: 'Portafogli archiviati',
    last_update: 'Ultimo aggiornamento',
    click_to_create_wallet: 'Clicca per creare un portafoglio',
    add_wallet: 'Aggiungi portafoglio',
    credit_card_settings: 'Impostazioni Carta di Credito',
    voucher_settings: 'Impostazioni Voucher',
    additional_options: 'Opzioni Aggiuntive',
    enter_initial_balance: 'Inserisci saldo iniziale',
    edit_wallet: 'Modifica Portafoglio',
    initial_balance: 'Saldo iniziale',
    label_settings: 'Impostazioni etichette',
    manage_your_labels: 'Gestisci le tue etichette, aggiungine di nuove o archivia quelle non utilizzate',
    add_new_label: 'Aggiungi nuova etichetta',
    edit_label: 'Modifica etichetta',
    add_label: 'Aggiungi etichetta',
    label_name: 'Nome etichetta',
    active_labels: 'Etichette attive',
    all_labels: 'Tutte le etichette',
    archived_labels: 'Etichette archiviate',
    no_labels_found: 'Nessuna etichetta trovata',
    balance: 'Saldo',
    manage_your_workspaces: 'Gestisci i tuoi spazi di lavoro',
    edit_workspace: 'Modifica spazio di lavoro',
    user_shared: 'Utente condiviso',
    enter_email: 'Inserisci email',
    no_workspaces_found: 'Nessun spazio di lavoro trovato',
    reset: 'Reimposta',
    category_details: 'Dettagli categoria',
    expenses_by_category_monthly: 'Spese per categoria (mensile)',
    expenses_by_category_comparison: 'Spese per categoria (confronto)',
    manage_your_models: 'Gestisci i tuoi modelli, aggiungine di nuovi o archivia quelli non utilizzati',
    write_template_name: 'Scrivi il nome del modello',
    sort_name_asc: 'Nome (A-Z)',
    sort_name_desc: 'Nome (Z-A)',
    sort_amount_desc: 'Importo (Alto-Basso)',
    sort_amount_asc: 'Importo (Basso-Alto)',
    notification_emails: 'E-mail di notifica',
    notification_thresholds: 'Soglie di notifica',
    notification_threshold_example: 'Es: 60 per 60%',
}
</script>